import React from 'react'
import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

const PublicRoute = () => {
  const isLogged = useSelector((state) => state.isLogged)
  const ACCtoken = useSelector((state) => state.ACCtoken)
  const location = useLocation()

  // Get the next path from query params or default to "/dashboard"
  const next = new URLSearchParams(location.search).get('next') || '/dashboard'

  // If user is already logged in, redirect to the next page
  if (isLogged && ACCtoken && ACCtoken !== 0) {
    return <Navigate to={next} replace />
  }

  // Otherwise, render the public route
  return <Outlet />
}

export default PublicRoute